<template>
    <b-loading :is-full-page="fullScreen" :active.sync="loading">
        <div class="ls-templated-loading">
            <div class="ls-templated-loading--image">
                <img src="@/assets/gray_loading_bg.png" />
                <img src="@/assets/purple_dots.svg" class="ls-templated-loading--image-dots" />
                <img src="@/assets/spinner.svg" class="ls-templated-loading--image-spinner" />
            </div>
            <span class="ls-templated-loading--text">Loading...</span>
        </div>
    </b-loading>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'LsTemplatedLoading',
    props: {
        show: VueTypes.oneOfType([Boolean, Number]).isRequired,
        fullScreen: VueTypes.bool.def(false),
    },
    computed: {
        loading() {
            return Boolean(this.show);
        },
    },
};
</script>

<style lang="scss">
.ls-templated-loading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: $z-ls-templated-loading-content;
}

.ls-templated-loading--image {
    position: relative;
}

.ls-templated-loading--image-dots {
    position: absolute;
    top: 46px;
    left: 46px;
}

.ls-templated-loading--image-spinner {
    position: absolute;
    top: 58px;
    left: 58px;
    animation: rotation 2s infinite linear;

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }
}

.ls-templated-loading--text {
    margin-top: 20px;
    font-size: 25px;
    color: #3c4368;
    font-weight: $semi-bold;
}
</style>
